module.exports = window.__LOAD_REMOTE_MODULE__('studentExperience');